import { Col, Form, Input, Row, Button, message } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import InputAnexo from "../../../../components/input-anexo";
import InputDate from "../../../../components/input-date";
import MiniForm from "../../../../components/mini-form";
import SelectBoolean from "../../../../components/select-boolean";
import SelectEmpresaProcuradorTipo from "../../../../components/select-empresa-procurador-tipo";
import InputNames from "../../../../components/input-names";
import SelectEmpresaProcuradorRepresentacao from "../../../../components/select-empresa-procurador-representacao";
import { openPopupAssinaturas, openPopupModelos } from "../../../../util/window";
import ActionButton from "../../../../components/action-button";
import { useEffect } from "react";
import InputCpf from '../../../../components/input-cpf';
import { isValidCpf } from "../../../../util/cpf";

export default function EmpresaProcuradorForm({ disabled, form, loading, onFinish, title, id, empresaId }) {
  const { t } = useTranslation();

  const handleOpenPopup = () => {
    openPopupModelos("procuradores", id, empresaId);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.tipo === "ARQUIVO_RENOMEADO") {
        const arquivoRecebido = event.data.conteudo;
        form.setFieldsValue({ anexo: arquivoRecebido });
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [form]);

  return (
    <MiniForm form={form} loading={loading} onFinish={onFinish}>
      {title}
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <Form.Item name="tipo" label={t("Tipo")}>
            <SelectEmpresaProcuradorTipo disabled={disabled} />
          </Form.Item>
        </Col>
        <Col flex="200px">
          <Form.Item name="representacao" label={t("Representação")}>
            <SelectEmpresaProcuradorRepresentacao allowClear disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <Form.Item label={t("Nomes")}>
            <Form.List name="nomes" initialValue={[{ nome: "", cpf: "", email: "" }]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Row gutter={8} align="middle" key={key}>
                      <Col flex="2 1 0px">
                        <Form.Item {...restField} name={[name, "nome"]} label={t("Nome")} rules={[]}>
                          <Input 
                            placeholder="Nome" 
                            disabled={disabled}
                            style={{ overflow: 'visible', whiteSpace: 'nowrap' }}
                          />
                        </Form.Item>
                      </Col>
  <Col flex="1 1 0px">
  <Form.Item 
    {...restField} 
    name={[name, "cpf"]} 
    label={t("Cpf")} 
    rules={[
      {
        validator: (_, value) => {
          if (!value || isValidCpf(value)) {
            return Promise.resolve();
          }
          return Promise.reject();
        },
      },
    ]}
  >
    <InputCpf disabled={disabled} />
  </Form.Item>
</Col>
                      <Col flex="2 1 0px">
                        <Form.Item {...restField} name={[name, "email"]} label={t("Email")} rules={[]}>
                          <Input 
                            placeholder="E-mail" 
                            disabled={disabled}
                            style={{ overflow: 'visible', whiteSpace: 'nowrap' }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        flex="40px"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <DeleteOutlined
                          style={{
                            color: "red",
                            fontSize: 20,
                            cursor: "pointer",
                            marginBottom: 10,
                          }}
                          onClick={() => remove(name)}
                        />
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add({ nome: "", cpf: "", email: "" })} block>
                      + Adicionar
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <Form.Item name="dataInicial" label={t("Data Inicial")}>
            <InputDate disabled={disabled} />
          </Form.Item>
        </Col>
        <Col flex="200px">
          <Form.Item name="indeterminado" label={t("Prazo Indeterminado")}>
            <SelectBoolean disabled={disabled} />
          </Form.Item>
        </Col>
  {!form.getFieldValue("indeterminado") && (
    <Col flex="200px">
      <Form.Item name="dataFinal" label={t("Data Final")}>
        <InputDate disabled={disabled} />
      </Form.Item>
    </Col>
  )}
        <Col flex="200px">
          <Form.Item name="aviso" label={t("Controle de Prazo")}>
            <SelectBoolean disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <Form.Item name="poderes" label={t("Poderes")}>
            <Input.TextArea autoSize disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <Form.Item label={t("Anexo")} shouldUpdate={(prevValues, nextValues) => prevValues.anexo !== nextValues.anexo}>
            {({ getFieldValue }) => {
              const existeAnexo = !!getFieldValue("anexo");
              return (
                <Row gutter={8} align="top">
                  <Col flex="auto">
                    <Form.Item name="anexo" noStyle>
                      <InputAnexo disabled={loading} />
                    </Form.Item>
                  </Col>
                 <Col>
                 <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  <ActionButton.Modelo onClick={handleOpenPopup} disabled={existeAnexo} />
                 </div>
                </Col>
                </Row>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <Form.Item name="obs" label={t("Observação")}>
            <Input.TextArea autoSize disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
    </MiniForm>
  );
}

EmpresaProcuradorForm.propTypes = {
  disabled: PropTypes.bool,
  form: PropTypes.object,
  loading: PropTypes.bool,
  onFinish: PropTypes.func,
  title: PropTypes.node,
};